import { FC } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectUserIsLoggedIn } from 'store/user/selectors';

import PrivateRoutes from './Private';
import PublicRoutes from './Public';

const Routes: FC = () => {
  const isLoggedIn = useAppSelector(selectUserIsLoggedIn);

  if (isLoggedIn) {
    return <PrivateRoutes />;
  }

  return <PublicRoutes />;
};

export default Routes;
